exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add_btn[data-v-f90cfb7c]{background:#4d8aff;border-radius:4px;padding:2px 10px;font-size:18px;color:#fff;margin-bottom:4px;margin-right:20px}[data-v-f90cfb7c] .dialog_box{border-radius:10px}[data-v-f90cfb7c] .dialog_box .el-dialog__header{border-radius:10px 10px 0 0;background:#ecf4ff;color:#282828;font-weight:600;font-size:22px}.text[data-v-f90cfb7c]{color:#817f7f}", ""]);

// exports
